import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";

import { dateConversion } from "../../../../components/Validation";

const WorkServiceInvoiceForm = (props) => {
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const frmRef = useRef({});
  const { sendRequest: postWorkServiceInvoice } = useHttp();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const [loading, setLoading] = useState(false);

  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState();
  const [close, setClose] = useState(false);
  const [labourDetails, setLabourDetails] = useState([]);
  const [total, setTotalValue] = useState({
    labour: 0,
    transfer: 0,
    meal: 0,
    dispercentage: 0,
    taxId: 0,
  });
  const [taxs, setTaxs] = useState();
  const [currancys, setCurrancys] = useState([]);

  const [vendorDetails, setVendorDetails] = useState([]);
  const [currencyId, setCurrencyId] = useState([]);
  const [servicDealTypeId, setServicDealTypeId] = useState();

  const [vendorId, setVendorId] = useState(0);

  const [workOrderId, setWorkOrderId] = useState(0);

  const [taxAmount, setTaxAmount] = useState(0);
  const [taxId, setTaxId] = useState(1);
  const [costInWords, setCostInWords] = useState();
  const roundValue = 2;
  const [wsoDocNo, setWsoDocNo] = useState();
  const [wsoData, setWsoData] = useState();

  const serviceDealType = [
    { value: 1, label: "Hourly" },
    { value: 2, label: "Fix Set of Hours" },
    { value: 3, label: "Work Based" },
    { value: 4, label: "Number of Days" },
    { value: 5, label: "Other" },
  ];

  const { sendRequest: getwsoIds } = useHttp();

  const { sendRequest: getVendor } = useHttp();
  useEffect(() => {
    getVendor(
      {
        url: `/api/getVendorNames/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setVendorDetails(res);
        }
      }
    );
  }, [getVendor]);

  useEffect(() => {
    getwsoIds(
      {
        url: `/api/workServiceOrder/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setWsoData(data);
      }
    );
  }, [getwsoIds]);

  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
        }
      }
    );
  }, [getCurrency]);

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  useEffect(() => {
    var serviceOrderAmount = 0;
    var discountAmount = 0;
    var amountafterdiscount = 0;

    var basicAmount =
      parseInt(total.labour) +
      parseFloat(total.meal) +
      parseFloat(total.transfer);
    basicAmount = basicAmount.toFixed(roundValue);

    //console.log(total.dispercentage);

    frmRef.current.lineTotalAmount.value = basicAmount;
    discountAmount = (basicAmount * parseFloat(total.dispercentage)) / 100;
    discountAmount = discountAmount.toFixed(roundValue);

    amountafterdiscount = basicAmount - discountAmount;
    //console.log(discountAmount);
    frmRef.current.discountAmount.value = discountAmount;
    // amountafterdiscount = amountafterdiscount;

    frmRef.current.total_amount.value = amountafterdiscount;

    ////console.log(amountafterdiscount);

    const filteredTaxPer =
      taxs &&
      taxs
        .filter((item) => parseInt(item.taxId) === parseInt(total.taxId))
        .map((item) => item.taxPercentage);

    //console.log("taxId", total.taxId, filteredTaxPer);

    var taxAmt = parseFloat((amountafterdiscount / 100) * filteredTaxPer) || 0;

    taxAmt = taxAmt.toFixed(roundValue);

    frmRef.current.taxAmount.value = parseFloat(taxAmt);

    //console.log(taxAmt);

    setTaxAmount(taxAmt);

    serviceOrderAmount = parseFloat(amountafterdiscount) + parseFloat(taxAmt);

    frmRef.current.totalWorkOrderAmount.value = serviceOrderAmount || 0;

    //console.log(serviceOrderAmount);
  }, [total, taxs]);

  const { sendRequest: pageloadfunction } = useHttp();

  useEffect(() => {
    pageloadfunction();
  }, [pageloadfunction]);

  const { sendRequest: getLoadWorkOrder } = useHttp();

  const loadWorkOrderData = (id) => {
    setWorkOrderId(id);
    getLoadWorkOrder(
      {
        url: `/api/workServiceOrder/?wsoId=${id}`,
      },
      (data) => {
        //console.log(data);
        setVendorId(data.vendorId);
        setCurrencyId(data.currencyId);
        setWsoDocNo(data.wsoDocNo);
        setTaxId(data.taxId);
        setServicDealTypeId(data.serviceDealType);
        // //console.log("work order", data);
        frmRef.current.labour_count.value = data.labourCount;
        frmRef.current.labour_cost.value = data.labourCost;
        frmRef.current.labour_transport_cost.value = data.labourTransportCost;
        frmRef.current.labour_meal_cost.value = data.labourMealCost;
        frmRef.current.lineTotalAmount.value = data.lineTotalAmount || 0;
        frmRef.current.taxAmount.value = data.taxAmount || 0;
        frmRef.current.discountPercentage.value = data.discountPercentage || 0;
        frmRef.current.discountAmount.value = data.discountAmount || 0;
        frmRef.current.total_amount.value = data.totalAmount;
        frmRef.current.totalWorkOrderAmount.value = data.totalWorkOrderAmount;
        frmRef.current.amt_chargeable.value = data.amountChargeable;
        setCostInWords(data.amountChargeable);
        setTotalValue({
          ...total,
          labour: data.labourCost,
          transfer: data.labourTransportCost,
          meal: data.labourMealCost,
          dispercentage: data.discountPercentage,
          taxId: data.taxId,
        });
      },
      (error) => {
        setVendorId("--Select--");
        setCurrencyId("--Select--");
        setTaxId("--Select--");
      }
    );
  };

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  useEffect(() => {
    frmRef.current.time_stamp.value =
      (d.getHours() < 10 ? "0" : "") +
      d.getHours().toString() +
      ":" +
      (d.getMinutes() < 10 ? "0" : "") +
      d.getMinutes().toString();
    //console.log("time_stamp1",d.getMinutes().toString())
  }, [getEmp]);

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    //console.log("costInWords",costInWords)
    const data = {
      wsiDocNo: wsoDocNo,
      wsiDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),

      workOrderInvoiceTimeStamp: frmRef.current.time_stamp.value,
      vendorId: vendorId,
      currencyId: frmRef.current.currency.value,
      serviceDealType: frmRef.current.servic_deal_type.value,
      supervisorEmployeeId: frmRef.current.emp_id.value,
      labourCount: frmRef.current.labour_count.value,

      labourCost: frmRef.current.labour_cost.value,
      labourTransportCost: frmRef.current.labour_transport_cost.value,
      labourMealCost: frmRef.current.labour_meal_cost.value,
      lineTotalAmount: frmRef.current.lineTotalAmount.value,
      discountPercentage: frmRef.current.discountPercentage.value,
      discountAmount: frmRef.current.discountAmount.value,
      totalAmount: frmRef.current.total_amount.value,
      taxId: frmRef.current.tax.value,
      taxAmount: frmRef.current.taxAmount.value,
      totalWorkOrderAmount: frmRef.current.totalWorkOrderAmount.value,
      wsoId: frmRef.current.work_service_order_id.value,
      terms: 90,
      remark: frmRef.current.remark.value,
      amountChargeable: costInWords,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      createdDate: dateString,
      serviceId: props.sId,
    };

    if (props.update) {
      data["wsiId"] = props.update.wsiId;
    }
    //console.log(data);
    postWorkServiceInvoice(
      {
        url: "/api/workServiceInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        props.addForm(false);
        toast.success(
          `Work Order Invoice ${props.update ? "Updated" : "Added"}`
        );
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  //const {  sendRequest: getwsoId } = useHttp();

  // const handleWork = (e) => {
  //   getwsoId(
  //     {
  //       url: `/api/workServiceOrder/?orgId=${localStorage.getItem(
  //         "orgId"
  //       )}&wsoId=${e.target.value}`,
  //     },
  //     (data) => {
  //       //console.log(data);
  //     }
  //   );
  // };

  //Edit Data Bind
  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      //console.log(moment(props.update.wsiDate).format("DD-MM-YYYY"));

      var wsoDate = dateConversion(
        props.update.wsiDate,
        "DD/MM/YYYY",
        "YYYY-MM-DD"
      );

      frmRef.current.date.value = props.update.wsiDate;

      setSelectedDate(wsoDate);

      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      frmRef.current.vendor_name.value = props.update.vendorId;
      setVendorId(props.update.vendorId);
      setCurrencyId(props.update.currencyId);
      // setWorkOrderId(props.wsoId)
      setTaxId(props.update.taxId);
      setWorkOrderId(props.update.wsoId);
      frmRef.current.servic_deal_type.value = props.update.serviceDealType;
      frmRef.current.labour_count.value = props.update.labourCount;
      setLabourDetails(props.update.labourDetails);
      frmRef.current.labour_cost.value = props.update.labourCost;
      frmRef.current.labour_transport_cost.value =
        props.update.labourTransportCost;
      frmRef.current.labour_meal_cost.value = props.update.labourMealCost;
      frmRef.current.currency.value = props.update.currency;
      frmRef.current.lineTotalAmount.value = props.update.lineTotalAmount;
      frmRef.current.taxAmount.value = props.update.taxAmount;

      frmRef.current.discountPercentage.value = props.update.discountPercentage;
      frmRef.current.discountAmount.value = props.update.discountAmount;
      frmRef.current.total_amount.value = props.update.totalAmount;
      frmRef.current.totalWorkOrderAmount.value =
        props.update.totalWorkOrderAmount;
      frmRef.current.amt_chargeable.value = props.update.amountChargeable;
      setCostInWords(props.update.amountChargeable);

      frmRef.current.remark.value = props.update.remark;
      setTotalValue({
        ...total,
        labour: props.update.labourCost,
        transfer: props.update.labourTransportCost,
        meal: props.update.labourMealCost,
        dispercentage: props.update.discountPercentage,
        taxId: props.update.taxId,
      });
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Work Service Invoice</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>
                        {"Assigned Supervisor Employee id"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                      >
                        <option selected disabled value="">
                          --Select Employee--
                        </option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                              selected={
                                props.update &&
                                x.empId === props.update.supervisorEmployeeId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"work_service_order_id"}>
                        {"Work Service order"}
                      </label>
                      <select
                        id="work_service_order_id"
                        className="form-control"
                        value={workOrderId}
                        required
                        ref={(el) =>
                          (frmRef.current["work_service_order_id"] = el)
                        }
                        onChange={(e) => {
                          loadWorkOrderData(e.target.value);
                        }}
                      >
                        <option value="">--Select--</option>

                        {wsoData &&
                          wsoData.map((x) => (
                            <option value={x.wsoId}>{x.wsoDocNo}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"vendor_name"}>{"Vendor Name"}</label>
                      <select
                        id="vendor_name"
                        className="form-control"
                        disabled
                        value={vendorId}
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                      >
                        <option>--Select--</option>
                        {vendorDetails &&
                          vendorDetails.map((x) => (
                            <option
                              key={x.vendorId}
                              vendor-id={x.vendorId}
                              value={x.vendorId}
                            >
                              {x.vendorName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"currency"}>{"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control"
                        disabled
                        ref={(el) => (frmRef.current["currency"] = el)}
                        value={currencyId}
                      >
                        <option>--Select--</option>

                        {currancys &&
                          currancys.map((x) => (
                            <option
                              key={x.currencyId}
                              value={x.currencyId}
                              currency-id={x.currencyId}
                            >
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"servic_deal_type"}>
                        {"Service Deal Type"}
                      </label>
                      <select
                        id="servic_deal_type"
                        className="form-control"
                        value={servicDealTypeId}
                        ref={(el) => (frmRef.current["servic_deal_type"] = el)}
                      >
                        <option>--Select--</option>
                        {serviceDealType &&
                          serviceDealType.map((x) => (
                            <option
                              key={x.value}
                              value={x.value}
                              value-id={x.value}
                            >
                              {x.label}
                            </option>
                          ))}
                      </select>

                      {/* <Select
                  className="form-control"
                  value={selectedEntry}
                  onChange={(e) => {
                    setSelectedEntry(e);
                    setFields({ ...fields, farmerType: e.value });
                  }}
                  options={farmerTypeOptions}
                /> */}
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_count"}>{"Labour Count"}</label>
                      <input
                        type={"text"}
                        id={"labour_count"}
                        required
                        ref={(el) => (frmRef.current["labour_count"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_cost"}>{"Labour Cost"}</label>
                      <input
                        type={"text"}
                        id={"labour_cost"}
                        // value={total.labour}
                        onChange={(e) =>
                          setTotalValue({ ...total, labour: e.target.value })
                        }
                        required
                        ref={(el) => (frmRef.current["labour_cost"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"labour_meal_cost"}>
                        {"Labour Meal Cost"}
                      </label>
                      <input
                        type={"text"}
                        id={"labour_meal_cost"}
                        onChange={(e) =>
                          setTotalValue({ ...total, meal: e.target.value })
                        }
                        required
                        ref={(el) => (frmRef.current["labour_meal_cost"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_transport_cost"}>
                        {"Labour Transport Cost"}
                      </label>
                      <input
                        type={"text"}
                        id={"labour_transport_cost"}
                        onChange={(e) =>
                          setTotalValue({ ...total, transfer: e.target.value })
                        }
                        required
                        ref={(el) =>
                          (frmRef.current["labour_transport_cost"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"lineTotalAmount"}>
                        {"Sub Total Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"lineTotalAmount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["lineTotalAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row"></div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"discountPercentage"}>
                        {"Discount(%)"}
                      </label>
                      <input
                        type={"text"}
                        id={"discountPercentage"}
                        onChange={(e) =>
                          setTotalValue({
                            ...total,
                            dispercentage: e.target.value,
                          })
                        }
                        ref={(el) =>
                          (frmRef.current["discountPercentage"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"discountAmount"}>
                        {"Discount Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"discountAmount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["discountAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"total_amount"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["total_amount"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control"
                        value={taxId}
                        ref={(el) => (frmRef.current["tax"] = el)}
                        // onChange={handleTaxChange}

                        onChange={(e) => (
                          setTaxId(e.target.value),
                          setTotalValue({ ...total, taxId: e.target.value })
                        )}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option key={x.taxId} value={x.taxId}>
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"taxAmount"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"taxAmount"}
                        disabled
                        required
                        ref={(el) => (frmRef.current["taxAmount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"tatotalWorkOrderAmountxAmount"}>
                        {"Work Order Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"totalWorkOrderAmount"}
                        disabled
                        required
                        ref={(el) =>
                          (frmRef.current["totalWorkOrderAmount"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <textarea
                        // type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        //className="inputs currancy-value"
                        value={costInWords}
                        rows="2"
                        cols="30"
                        style={{ resize: "none" }}
                        disabled
                      ></textarea>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default WorkServiceInvoiceForm;
